import { render, staticRenderFns } from "./EditorMenuGroup.vue?vue&type=template&id=4da83ac4&scoped=true&"
import script from "./EditorMenuGroup.vue?vue&type=script&lang=js&"
export * from "./EditorMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditorMenuGroup.vue?vue&type=style&index=0&id=4da83ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da83ac4",
  null
  
)

export default component.exports